import { TranslationType } from '../components/HbtPortfolioManagementTable/types';

export const occupancyMapping = (t: TranslationType) => {
  const mapping = {
    '01': t('Pi-Portfolio-Management-Table-Occupancy-Mapping-H', 'Homeowner'),
    '02': t('Pi-Portfolio-Management-Table-Occupancy-Mapping-SR', 'Small Rental')
  };
  return mapping;
};
